<template>
  <div class="main-container">
    <div class="container">
      <TopAside class="topAside"/>
      <Content />
    </div>
  </div>
</template>

<script>
import TopAside from "./top-aside";
import Content from "./content";

export default {
  data() {
    return {};
  },

  components: {
    TopAside,
    Content,
  },
};
</script>

<style lang="less">
.main-container {
  height: 100%;
  min-width: 950px;
  box-sizing: border-box;
  width: 85%;

  .container {
    width: 100%;
    height: calc(100vh - 50px);
    overflow: auto;
    // padding-top: 50px;


    &::-webkit-scrollbar {
      width: 5px;
    }

    &::-webkit-scrollbar-thumb {
      background: radial-gradient(circle, #64b3f4, #c2e59c);
      border-radius: 5px;
    }
  }
}
</style>
